import React from 'react';
import LoginForm from '../components/LoginForm';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function InicioSesion() {
  return (
    <>
      <Navbar />
      <div className='header-space'>
        <LoginForm />
      </div>
      <Footer />
    </>
  );
}

export default InicioSesion;
